import React, { useState } from "react";
import { Button } from "react-bootstrap";
import * as Styled from "./RollAdsItem.styled";
import backgroundImage from "../../../../../assets/images/upload-image.svg";
import plusIcon from "../../../../../assets/images/icons/plus.png";
import { RollAdsModal } from "../../roll-ads-modal";

interface RollAdsModal{

  fetchCampaigns: () => void;
 
}
export const RollAdsItem: React.FC<RollAdsModal> = ({fetchCampaigns}) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <Styled.RollAdsWrapper>
      <Styled.BackgroundSVG src={backgroundImage} alt="Upload Image" />
      <Styled.TextContainer>
        <Styled.Text>You have no</Styled.Text>
        <Styled.SubText>campaigns yet</Styled.SubText>
      </Styled.TextContainer>
      <Styled.ButtonContainer>
        <Button variant="primary" onClick={() => setShowModal(true)}>New Campaign 
            <Styled.PlusIcon src={plusIcon} alt="Plus Icon" />
        </Button>
          {showModal && <RollAdsModal show={showModal}  onClose={() => setShowModal(false)} campaignId={null} fetchCampaigns={fetchCampaigns}/>}
      </Styled.ButtonContainer>
    </Styled.RollAdsWrapper>
  );
};
